import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../../lib/utils.js";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-[0.6rem] py-[0.2rem] text-xs font-semibold leading-tight whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "border border-border bg-surface-muted text-muted",
        success: "border border-transparent bg-success-muted text-success",
        warning: "border border-transparent bg-warning-muted text-warning",
        error: "border border-transparent bg-error-muted text-error",
        whatsapp: "border border-transparent bg-whatsapp-muted text-success",
        outline: "border border-border-strong bg-transparent text-muted",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  ),
);
Badge.displayName = "Badge";
